import { useMemo } from 'react';

import { useMembershipModalState } from '../../../../modalContext';

type SelectionCardStyles = Readonly<{
	borderBackgroundColor: string;
	borderColor: string;
	backgroundColor: string;
}>;

type Result = ModelHookResult<SelectionCardStyles, undefined>;

const VARIANT_STYLES = {
	checked: {
		borderBackgroundColor: 'sunrise.gradient.fill.interactive.default',
		borderColor: 'transparent',
		backgroundColor: 'sunrise.semantic.fill.inverse.strong',
	},
	unchecked: {
		borderBackgroundColor: 'sunrise.semantic.fill.inverse.strong',
		borderColor: 'sunrise.semantic.stroke.inverse.strong',
		backgroundColor: 'sunrise.semantic.fill.inverse.strong',
	},
} as const;

const CONTROL_STYLES = {
	checked: {
		borderBackgroundColor: 'linear-gradient(275deg, #0139BC 2.93%, #4BAEFF 96.39%)',
		borderColor: 'sunrise.semantic.stroke.weaker',
		backgroundColor: 'sunrise.semantic.fill.accent.primary.weaker',
	},
	unchecked: {
		borderBackgroundColor: 'transparent',
		borderColor: 'sunrise.semantic.stroke.weaker',
		backgroundColor: 'sunrise.semantic.fill.inverse.strong',
	},
} as const;

export function useSelectionCard(checked: boolean): Result {
	const [{ koiPpmuDesignExperimentVariant }] = useMembershipModalState();

	const data = useMemo(() => {
		const isVariant3 = koiPpmuDesignExperimentVariant === 'variant_3';
		const styleSet = isVariant3 ? VARIANT_STYLES : CONTROL_STYLES;
		return checked ? styleSet.checked : styleSet.unchecked;
	}, [koiPpmuDesignExperimentVariant, checked]);

	return { data };
}
